import { createFileRoute } from "@tanstack/react-router"
import { PageLoading } from "~/components/PageLoading"
import CustomHead from "~/components/SEOHead/CustomHead"
import GeneralInformationEdit from "~/components/Settings/GeneralInformationEdit"
import { useAuthSession } from "~/hooks/useAuthSession"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"
import { getInternalPageTitle, InternalSection } from "~/utils/seo"

export const Route = createFileRoute("/account")({
  component: Account,
})

function Account() {
  const { session } = useAuthSession()
  const { data: user, isLoading } = api.users.getUserWithTeam.useQuery(undefined, {
    enabled: session?.user?.id != null,
  })

  if (isLoading || user == null) {
    return <PageLoading />
  }

  return (
    <AppLayout>
      <CustomHead title={getInternalPageTitle(InternalSection.ACCOUNT_SETTINGS)} />
      <GeneralInformationEdit user={user} />
    </AppLayout>
  )
}
